



















































































import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const boxes = require('@/components/boxes').default;

const SheetBoxProps = Vue.extend({
  props: {
    height: [String, Number],
    itemId: String,
    editMode: Boolean,
    type: {
      type: String,
      validator(value: string) {
        return Object.keys(boxes).includes(value);
      },
    },
  },
});

@Component
export default class SheetBox extends SheetBoxProps {
  get componentType() {
    return (boxes as any)[this.$props.type];
  }

  get headerAddon() {
    // TODO: not sure how to access this or make it accessible w/o much indirection
    const componentType = (boxes as any)[this.$props.type];
    // TODO: change to Object.hasOwn once sure that Apple/Safari support can be dropped
    // eslint-disable-next-line no-prototype-builtins
    if (componentType?.hasOwnProperty('HeaderAddon')) {
      return componentType.HeaderAddon;
    }
    return undefined;
  }

  get showRemoveButton() {
    return this.$props.editMode && this.componentType.optional;
  }

  onRemoveClicked() {
    this.$emit('remove');
  }
}

